// extracted by mini-css-extract-plugin
module.exports = {"viewButton":"ViewButton_viewButton__3MBcN","viewButtonText":"ViewButton_viewButtonText__2Y3cZ"};